'use client'

import { type FC, type ReactNode, createContext, useEffect, useState } from 'react'

export const Themes = {
    dark: 'dark',
    light: 'light',
} as const

type Theme = (typeof Themes)[keyof typeof Themes]

export interface ThemeContextProps {
    theme: Theme
    setTheme: (theme: Theme) => void
}

// Provide a non-null default value
export const ThemeContext = createContext<ThemeContextProps | null>(null)

interface Props {
    children: ReactNode
    defaultTheme?: Theme
}

export const ThemeProvider: FC<Props> = ({ children, defaultTheme = 'dark' }) => {
    const [theme, setTheme] = useState<Theme>(defaultTheme)

    // Update theme state when defaultTheme prop changes
    useEffect(() => {
        setTheme(defaultTheme)
    }, [defaultTheme])

    // Apply theme class to document element
    useEffect(() => {
        const allThemes = Object.values(Themes)
        document.documentElement.classList.remove(...allThemes)
        document.documentElement.classList.add(theme)
    }, [theme])

    return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
}
